import { flow, find, isEmpty } from "lodash/fp";
import identity from "lodash/fp/identity";
import constants from "../../core/constants";
import moment from "moment";
import { toObject, parsePrice } from "../../core/utils";

class BookingPageTransform {
  constructor(Lists) {
    "ngInject";

    this.Lists = Lists.all;
  }

  justify(data) {
    const format = (item) => {
      const formatTransaction = (transaction) => {
        transaction.creditsAmount /= constants.currencyBy;
        transaction.cardAmount /= constants.currencyBy;
        transaction.debtAmount /= constants.currencyBy;
        transaction.subTotal /= constants.currencyBy;
        transaction.promotionDeduction /= constants.currencyBy;
        transaction.packageAmount /= constants.currencyBy;
        transaction.total /= constants.currencyBy;
        transaction.serviceFeeApplied /= constants.currencyBy;
        transaction.subscriptionDeduction = transaction.subscriptionDeduction
          ? transaction.subscriptionDeduction / constants.currencyBy
          : "N/A";
        return transaction;
      };

      item.date = moment(item.date).format(constants.dateTimeFormat);
      if (item.transferred_rides) {
        item.transferred_rides.forEach((object) => {
          object.old_ride.date = moment(object.old_ride.date).format(
            constants.timeFormat
          );
          object.createdAt = moment(object.createdAt).format(
            constants.dateTimeFormat
          );
        });
      }

      if (item.cash_collection_meta) {
        item.cash_collection_meta.timestamp = moment(
          item.cash_collection_meta.timestamp
        ).format(constants.dateTimeFormat);
      }
      item.is_dynamically_priced = !isEmpty(item.pricing_parameters);
      if (item.pricing_parameters) {
        item.pricing_parameters.base_fare /= constants.currencyBy;
        item.pricing_parameters.maximum_fare /= constants.currencyBy;
        item.pricing_parameters.time_fare.bucket_fare /= constants.currencyBy;
        item.pricing_parameters.distance_fare.bucket_fare /=
          constants.currencyBy;
        item.pricing_parameters.distance_fare.total_fare /=
          constants.currencyBy;
        item.pricing_parameters.time_fare.total_fare /= constants.currencyBy;
        item.pricing_parameters.peak_multiplier /= constants.currencyBy;
        item.pricing_parameters.total_fare = (
          item.pricing_parameters.base_fare +
          item.pricing_parameters.distance_fare.total_fare +
          item.pricing_parameters.time_fare.total_fare
        ).toFixed(2);
        item.pricing_parameters.followCityMaxFare =
          item.pricing_parameters.total_fare >
          item.pricing_parameters.maximum_fare;
      }
      item.pick_up_time = item.pick_up_time
        ? moment(item.pick_up_time).format(constants.dateTimeFormat)
        : null;
      item.drop_off_time = item.drop_off_time
        ? moment(item.drop_off_time).format(constants.dateTimeFormat)
        : null;
      // ETA AND ETD
      item.promised_pick_up_time = item.promised_pick_up_time
        ? moment(item.promised_pick_up_time).format(constants.dateTimeFormat)
        : null;
      item.promised_drop_off_time = item.promised_drop_off_time
        ? moment(item.promised_drop_off_time).format(constants.dateTimeFormat)
        : null;

      item.check_in_time = item.check_in_time
        ? moment(item.check_in_time).format(constants.dateTimeFormat)
        : null;
      item.cancellation_date = item.cancellation_date
        ? moment(item.cancellation_date).format(constants.dateTimeFormat)
        : null;

      item.status = find((i) => i.name === item.status)(
        this.Lists.bookingStatus
      );
      item.cash_collection_status = find(
        (i) => i.name === item.cash_collection_status
      )(this.Lists.cashCollectionStatus);
      item.price = parsePrice(item.price);
      item.extra_paid = parsePrice(item.extra_paid);
      item.feedback = item.feedback ? [item.feedback] : [];
      item.transactions = item.transactions.map(formatTransaction);
      if (item.ride) {
        item.rideName = `${item.ride.route.name} ${moment(
          item.ride.date
        ).format(constants.dateTimeFormat)}`;
        if (item.ride.currency) {
          item.price = `${item.price} ${item.ride.currency}`;
          item.extra_paid = `${item.extra_paid} ${item.ride.currency}`;
          item.currency = item.ride.currency;
        }
      } else if (item.dynamic_trip && item.dynamic_trip.route) {
        item.rideName = `${item.dynamic_trip.route.name}`;
        item.price = `${item.price} ${item.dynamic_trip.route.currency}`;
        item.extra_paid = `${item.extra_paid} ${item.dynamic_trip.route.currency}`;
        item.currency = item.dynamic_trip.route.currency;
      }

      item.receipt.reschedule_fee = item.receipt.reschedule_fee
        ? item.receipt.reschedule_fee / constants.currencyBy
        : 0;
      item.receipt.commuter_package_discount = item.receipt
        .commuter_package_discount
        ? item.receipt.commuter_package_discount / constants.currencyBy
        : 0;

      return item;
    };
    return toObject(flow([format, identity])(data));
  }
}

export default BookingPageTransform;



// WEBPACK FOOTER //
// ./src/pages/booking/booking.transforms.js